import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ title, updated, sections }) {
  return (
    <div className="min-h-screen relative" style={{ background: "radial-gradient(1200px 600px at 50% -5%, #16130B 0%, #0C0B0C 42%, #0A0A0B 100%)" }}>
      {/* Nav */}
      <nav className="relative z-10 flex items-center justify-between max-w-3xl mx-auto px-5 sm:px-8 py-5">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
          <div className="h-8 w-8 rounded-md bg-primary flex items-center justify-center text-primary-foreground font-extrabold" style={{ fontFamily: "'Manrope', sans-serif" }}>C</div>
          <span className="font-extrabold text-lg tracking-tight no-underline" style={{ fontFamily: "'Manrope', sans-serif" }}>Channel<span className="text-primary">HQ</span></span>
        </Link>
        <Link to="/" data-testid="legal-back-link"
          className="flex items-center gap-2 text-sm font-medium border border-border rounded-md px-4 py-2 hover:bg-secondary transition-colors duration-200">
          <ArrowLeft size={15} /> Back
        </Link>
      </nav>

      <main className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 py-12 fade-up" data-testid="legal-content">
        <p className="font-mono text-xs text-primary tracking-[0.28em] uppercase mb-4">Legal</p>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight">{title}</h1>
        <p className="font-mono text-xs text-muted-foreground mt-3">Last updated: {updated}</p>

        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display font-bold text-xl tracking-tight mb-3">{s.heading}</h2>
              {s.body.map((p, j) => (
                <p key={j} className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-3">{p}</p>
              ))}
            </section>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Questions? Contact us at <span className="text-primary font-medium">support@channelhq.app</span>.
          </p>
        </div>
      </main>

      <footer className="relative z-10 border-t border-border mt-8">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs text-muted-foreground">© 2026 ChannelHQ — built for solo creators.</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-xs text-muted-foreground hover:text-primary transition-colors duration-200">Privacy Policy</Link>
            <Link to="/terms" className="text-xs text-muted-foreground hover:text-primary transition-colors duration-200">Terms of Service</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
